@if (notifications$ | async; as notifications) {
  <button [appTooltip]="'app.navigation.notifications.tooltip' | translate"
    (click)="toggleBadgeVisibility(notifications)" class="active p-2 hover:rotate-6">
    <app-svg-images [svgName]="notifications.length ? 'bell-alert-solid' : 'bell-solid'"
      class="h-5 flex text-gray-500 dark:text-white/80"></app-svg-images>
  </button>
}
